import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SearchFilter from './FilterView.vue'


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'LoadableFiltersView',
  props: {
    filters: {},
    listResource: {},
    permanent: {},
    filterParameters: {}
  },
  emits: ["update:filters"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

function changeFilters(value: any) {
  emit('update:filters', value);
}

return (_ctx: any,_cache: any) => {
  const _component_resource_loader_controller = _resolveComponent("resource-loader-controller")!

  return (_openBlock(), _createBlock(_component_resource_loader_controller, { resource: _ctx.listResource }, {
    default: _withCtx((allProps) => [
      _createVNode(SearchFilter, _mergeProps({
        value: _ctx.filters,
        permanent: _ctx.permanent,
        parameters: _ctx.filterParameters,
        onInput: changeFilters,
        "all-props": allProps
      }, _ctx.$attrs), {
        append: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, "append", _normalizeProps(_guardReactiveProps(scope)))
        ]),
        _: 2
      }, 1040, ["value", "permanent", "parameters", "all-props"])
    ]),
    _: 3
  }, 8, ["resource"]))
}
}

})